import DefaultModal from '../../../../components/Modal/DefaultModal';
import React, { useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import ProtocolService from '../../service';
import { toast } from 'react-toastify';
import { Row, Form, Col, Button, Input } from 'reactstrap';

const ModalStatus = ({
  isModalOpen,
  onModalToggle,
  idProtocol,
  dataComment,
  render,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);

  const { control, handleSubmit, errors } = useForm();

  const onSubmit = async (data) => {
    try {
      let message;
      const { id } = dataComment;
      await ProtocolService.updateComment(idProtocol, id, data);

      message = 'Comentário atualizado com sucesso';
      toast.success(message, {
        autoClose: 3000,
        closeOnClick: true
      });
      closeModal();
    } catch (err) {
      console.log(err);
      toast.error(' Erro ao atualizar o comentário', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      render();
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Alterar descrição do comentário"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md="12">
              <label className="form-control-label">Descrição*</label>

              <Controller
                as={Input}
                control={control}
                name="description"
                rules={{
                  required: 'Campo obrigatório'
                }}
                defaultValue={dataComment.description}
              />
              <ErrorMessage
                errors={errors}
                name="description"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          <hr />
          <Button color="primary" type="submit">
            Salvar
          </Button>
          <Button color="danger" onClick={closeModal}>
            Voltar
          </Button>
        </Form>
      </>
    </DefaultModal>
  );
};

export default ModalStatus;
